import React from "react";
import clsx from "clsx";
import { InputAdornment } from "@mui/material";
import PasswordAdornment from "./VerifyPasswordAdornment";
import {
  AdornmentProps,
  TypesAdornment,
  VerifyAdornment,
  VerifyAdornmentProps,
  VerifyPasswordAdornmentProps
} from "./index";

function Adornments<TypeF extends TypesAdornment>({
  position,
  children,
  type = "children",
  ...props
}: AdornmentProps<TypeF>) {
  switch (type) {
    case "children":
      return (
        <InputAdornment
          sx={{ backgroundColor: "transparent" }}
          position={position}
          className={clsx({
            "ml-2": position === "start",
            "mr-2": position === "end"
          })}
        >
          {children}
        </InputAdornment>
      );
    case "verify":
      return (
        <InputAdornment sx={{ backgroundColor: "transparent" }} position={position}>
          <VerifyAdornment {...(props as VerifyAdornmentProps)} />
        </InputAdornment>
      );
    case "verify-password":
      return (
        <InputAdornment sx={{ backgroundColor: "transparent" }} position={position}>
          <PasswordAdornment {...(props as VerifyPasswordAdornmentProps)} />
          <VerifyAdornment {...(props as VerifyAdornmentProps)} />
        </InputAdornment>
      );

    default:
      return null;
  }
}

export default Adornments;
